import Currency from 'react-currency-formatter';

const Price = ({ price = 0, placeholder }) => typeof placeholder !== 'undefined' && !Number(price) ?
    placeholder : <Currency quantity={Number(price)} currency="EUR" pattern="##,### !" group=" " />;

export default Price;
